export default __webpack_public_path__ + "static/media/vtc-logo.3d4b1fcf.png";